webpackJsonp([109151871106967],{

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Input","methods":[{"name":"onUpdate","docblock":null,"modifiers":[],"params":[{"name":"prevProps","type":null}],"returns":null},{"name":"onChange","docblock":null,"modifiers":[],"params":[{"name":"$event","type":null}],"returns":null}],"props":{"className":{"type":{"name":"string"},"required":false,"description":"CSS Class to apply to input.","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"null","computed":false}},"type":{"type":{"name":"string"},"required":false,"description":"Input type. Can be <code>'text'</code>, <code>'number'</code>, <code>'email'</code> and <code>'textarea'</code>","defaultValue":{"value":"'text'","computed":false}},"id":{"type":{"name":"string"},"required":false,"description":"Input id.","defaultValue":{"value":"''","computed":false}},"name":{"type":{"name":"string"},"required":false,"description":"Input name.","defaultValue":{"value":"''","computed":false}},"value":{"type":{"name":"string"},"required":false,"description":"Input value.","defaultValue":{"value":"''","computed":false}},"placeholder":{"type":{"name":"string"},"required":false,"description":"Input placeholder.","defaultValue":{"value":"''","computed":false}},"icon":{"type":{"name":"string"},"required":false,"description":"Icon to show with input.","defaultValue":{"value":"''","computed":false}},"iconAlign":{"type":{"name":"string"},"required":false,"description":"Align of icon. Can be <code>'left'</code> and <code>'right'</code>","defaultValue":{"value":"'left'","computed":false}},"label":{"type":{"name":"string"},"required":false,"description":"Label to show on input top.","defaultValue":{"value":"''","computed":false}},"size":{"type":{"name":"string"},"required":false,"description":"Size of input. Can be <code>'lg'</code> or <code>'sm'</code>.","defaultValue":{"value":"''","computed":false}},"onChange":{"type":{"name":"func"},"required":false,"description":"Called when input change. Params `{value}`","defaultValue":{"value":"() => {}","computed":false}}},"filename":"/components/Input/Input.jsx"}

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _input = __webpack_require__(517);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _map = __webpack_require__(1086);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _input2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _input2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Input',
	        description: _input2.default.summary,
	        stories: _input2.default.stories,
	        importCode: _input2.default.import,
	        withStyles: _input2.default.withStyles,
	        extractProps: _input2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Input',
	  summary: 'The Input specifies an input field where the user can enter data. Input elements are used within a <form> element to declare input controls that allow users to input data. An input field can vary in many ways, depending on the type attribute.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: 'The component supports differents input types: text, number, email and textarea.',
	    code: '<Input\n    name="myInput"\n    placeholder="Enter a value"\n    label="Input label"\n    icon="fa fa-user"\n/>',
	    tabsActive: ['code']
	  }, {
	    name: 'Size',
	    summary: 'Differentiating input sizes helps the user to know which is the most important part of the form.',
	    code: '<>\n    <Input name="Large" value="This is an large input" placeholder="Enter a value" icon="fa fa-user" size="lg"/>\n    <Input name="Normal" value="This is an normal input" placeholder="Enter a value" icon="fa fa-user"/>\n    <Input name="Small" value="This is an small input" placeholder="Enter a value" icon="fa fa-user" size="sm"/>\n</>',
	    tabsActive: []
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-input-js-d6347547e94bcd4b512d.js